import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sub-success-stories',
  templateUrl: './sub-success-stories.component.html',
  styleUrls: ['./sub-success-stories.component.scss']
})
export class SubSuccessStoriesComponent implements OnInit {
  pageTitle: string = '';
  routeTitleMap: { [key: string]: string } = {
    'success-story-1': 'Success Story 1',
    'success-story-2': 'Success Story 2',
    'success-story-3': 'Success Story 3',
  };
  constructor(public router: Router,) {
    this.setPageTitle();
   }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }
  setPageTitle() {
    this.router.events.subscribe(() => {
      const currentRoute = this.router.url.split('/').pop(); // Get the last segment of the URL
      this.pageTitle = this.routeTitleMap[currentRoute] || ''; // Set title based on mapping
    });
  }
}
